import { createHOC } from 'vue-hoc';

import withUser from '~lib/common/hoc/withUser';
import fetchOrgData from '~lib/common/utils/fetchOrgData';

import dataView from '~lib/common/hoc/dataView';
import queries from '../../../graphql/queries/Assignment';
import AssignmentList from './AssignmentList';
// import gradingClient from '../../../providers/gradingClient';
// import getResultsByUser from './getResultsByUser';
import getAssignmentUserIds from '../../../utils/getAssignmentUserIds';

const options = {
  name: 'AssignmentListContainer',
  data() {
    return {
      state: {
        assignments: null,
        orgData: null,
      },
    };
  },
  async created() {
    fetchOrgData(this.user).then(
      result => {
        this.state.orgData = result;
        // Prevent computation of % complete since it causes too many requests
        // this.fetchAndComputeAll();
      },
      error => {
        console.log(error);
      }
    );
  },
  methods: {
    // async fetchAndComputeAll() {
    //   const now = new Date().toJSON();
    //   const notPending = this.data.filter(a => a.startTime < now);

    //   const results = notPending.map(assign => ({
    //     assignment: assign,
    //     users: this.getUsers(assign),
    //     reports: undefined,
    //   }));

    //   const reportList = await Promise.all(
    //     results.map(res => this.fetchReports(res.assignment, res.users))
    //   );
    //   for (let i = 0; i < results.length && i < reportList.length; i += 1) {
    //     const assignment = results[i].assignment;
    //     const users = results[i].users;
    //     const reports = reportList[i];
    //     const idx = this.data.findIndex(a => a.id === assignment.id);
    //     this.data.splice(idx, 1, {
    //       ...assignment,
    //       percentComplete: this.computePercentComplete(reports, users),
    //     });
    //   }
    //   this.$analytics.event('Assignments', 'assignments_loaded', {
    //     pending_assignments_count: this.data.filter(a => a.startTime > now).length,
    //     active_assignments_count: this.data.filter(a => a.startTime <= now && a.endTime >= now).length,
    //     complete_assignments_count: this.data.filter(a => a.endTime < now && a.status !== 'REMOVED').length
    //   });
    // },
    // async fetchReports(assignment) {
    //   const response = await gradingClient.get('/reports', {
    //     filter: { assignmentId: assignment.id },
    //   });
    //   return response.data.gradingreports;
    // },
    // computePercentComplete(reports, allUsers) {
    //   const byUser = getResultsByUser(reports);
    //   if (allUsers.length > 0) {
    //     let numPassed = 0;
    //     Object.entries(byUser).forEach(result => {
    //       if (result[1].successful) {
    //         numPassed += 1;
    //       }
    //     });
    //     return Math.round((numPassed / allUsers.length) * 100);
    //   }
    //   return 0;
    // },
    getUsers(assignment) {
      return getAssignmentUserIds(assignment, this.state.orgData.groups);
    },
  },
};

const renderWith = {
  props: {
    orgData() {
      return this.state.orgData;
    },
  },
  listeners: {
    deleteTask(assignment) {
      this.$emit('remove', assignment);
    },
    startTask(assignment) {
      const startTime = new Date().toJSON();
      this.$emit('save', {
        id: assignment.id,
        startTime,
      });
    },
    completeTask(assignment) {
      const endTime = new Date().toJSON();
      this.$emit('save', {
        id: assignment.id,
        endTime,
      });
    },
    removeTask(assignment) {
      this.$emit('save', {
        id: assignment.id,
        status: 'REMOVED',
      });
    },
    deleteInProgress(assignment) {
      // In progress assignments are deleted by setting their status to
      // deleted, which triggers the background task in cases service to
      // do the actual deleting and modifying the caseConf record to
      // remove access to it from the assignment's students
      this.$emit('save', {
        id: assignment.id,
        status: 'DELETED',
      });
      const idx = this.data.findIndex(a => a.id === assignment.id);
      this.data.splice(idx, 1);
    },
    resetTask(assignment) {
      // Temporary testing code - send to pending
      const startTime = new Date();
      startTime.setDate(startTime.getDate() + 1);
      const endTime = new Date();
      endTime.setDate(endTime.getDate() + 3);
      this.$emit('save', {
        id: assignment.id,
        startTime,
        endTime,
        status: 'PENDING',
      });
    },
  },
};

const AssignmentListContainer = createHOC(AssignmentList, options, renderWith);
const containerWithUser = withUser()(AssignmentListContainer);
export default dataView({ queries, append: true })(containerWithUser);
